import { useEffect, useState } from "react"
import { useParams } from "react-router"
import { Loading } from "src/libs/useful"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { actions } from "../../data/actions"
import { GET_TEST_ACTION, GET_TEST_USER_RESULT_ACTION } from "../../data/actionTypes"
import { IPETest } from "../../data/interfaces"
import { ITestsStore, useTestsStore } from "../../data/store"
import Diagram from "../single/results/Diagram"
import { useUser } from "src/settings/zustand/user"
import { __, jsonToData } from "src/libs/utilities"

/* 
    Protopia Ecosystem component 
    Single User test result
*/ 
const UserTestsResults = (): JSX.Element => { 
    const user = useUser()
    const {width} = useScreenSize()
    const userResults = useTestsStore((state: ITestsStore) => state.userResults)
    const {userId, testId} = useParams()
    const [results, setResults] = useState<any[]>([])
    const [test, setTest] = useState<IPETest>({} as IPETest )
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [_width, set_Width] = useState<number>( 600)

    useEffect(() => {  
        set_Width( width < 900 ? width - 50 : 850 )

        actions(
            GET_TEST_ACTION, 
            {
                id:testId, 
            }
        ).then((result:IPETest) => {
            const test: IPETest = {
                ...result, 
                questions: result.questions
            }  
            setTest( test )
            actions(
                GET_TEST_USER_RESULT_ACTION, 
                {
                    user_id: userId,
                    test_id: testId
                }
            ).then(res => { 
                const results = jsonToData( res.results ) 
                setResults(  results  )
                setIsLoading( false )    
            })
            
        })
    }, []) 

    if(isLoading) {
        return <Loading />
    } 

    return <div className="d-flex w-100 flex-column">
        <div className="lead-md text-center w-100">
            {test.title}
        </div>
        <div className='pe-user-test-results-container' >
            <Diagram results={results} test={ test } width={_width}/>
        </div>
    </div>
}
export default UserTestsResults